// eslint-disable import/first
import Vue from 'vue'
import Router from 'vue-router'
import Page from '@/components/Page'
import NotFound from '@/components/NotFound'
import Invalid from '@/components/Invalid'
import(/* webpackPrefetch: true */ '../components/Splash.vue')
import(/* webpackPrefetch: true */ '../components/Button.vue')
import(/* webpackPrefetch: true */ '../components/Page.vue')
import(/* webpackPrefetch: true */ '../components/Survey.vue')
import(/* webpackPrefetch: true */ '../components/NotFound.vue')

Vue.use(Router)

export default new Router({
  base: '/enter/' + window.convinceConfig.campaignSlug,
  routes: [
    { path: '*', redirect: '/' },
    {
      name: 'Splash',
      path: '/',
      component: Page
    },
    {
      name: 'result',
      path: '/result/:responseUuid',
      component: Page
    },
    {
      name: 'page',
      path: '/p/:id',
      component: Page
    },
    {
      name: 'not_found',
      path: '/not_found',
      component: NotFound
    },
    {
      name: 'invalid',
      path: '/invalid',
      component: Invalid
    }
  ]
})
